// Module
var code = "<md-icon class=\"material-icons md-{{ ::size }} work-order-priority-icon work-order-priority-icon--medium\" md-svg-icon=\"/img/priority/medium.svg\"></md-icon> ";
// Exports
module.exports = code;